module.exports = "/_next/static/images/howWorks-e21fee50ebab84c118bb7ec5347554ea.jpg.webp";